import React, { useEffect, useState } from 'react';
import api from 'services';
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from 'helpers/useDebounce';

/**
 * 
 * @param {{ 
 *  getError: Function, 
 *  modifiedFields?: any, 
 *  underStyle?: any, 
 *  changeAutoComplete: Function,
 *  _registeredOwnerObject: { _id: string, name: string },
 *  confirmed?: boolean,
 * }} param0 
 * @returns 
 */
function RegisteredOwner({
    getError,
    modifiedFields,
    underStyle,
    changeAutoComplete,
    confirmed,
    _registeredOwnerObject,
}) {
    const [companies, setCompanies] = useState([]);
    const [registeredOwnerObject, setRegisteredOwnerObject] = useState(_registeredOwnerObject);

    useEffect(() => {
        setRegisteredOwnerObject(_registeredOwnerObject);
    }, [_registeredOwnerObject._id]);

    const debouncedSearchValue = useDebounce(registeredOwnerObject ? registeredOwnerObject.name : '', 500);

    useEffect(() => {
        if (debouncedSearchValue.length < 2) {
            return;
        }

        api.findCompany(debouncedSearchValue)
            .then((response) => {
                if (response.status === 200) {
                    const foundCompanies = response.data.data.map(company => ({
                        name: company.name,
                        company,
                    }));

                    setCompanies(foundCompanies);
                }
            })
            .catch((error) => {
                console.error('Error AutoComplete', error);

                return null;
            });
    }, [debouncedSearchValue]);

    const changeAutoCompete = (searchText) => {
        if (!searchText) {
            changeAutoComplete('registeredOwner', { _id: '', name: '' });
        }

        const data = {
            _id: '', name: searchText,
        };

        setRegisteredOwnerObject(data);

        changeAutoComplete('registeredOwner', data);
    };

    const chooseAutoComplete = (updateProperties) => {
        if (!updateProperties.company) return;
        setRegisteredOwnerObject(updateProperties.company);
        changeAutoComplete('registeredOwner', updateProperties.company);
    };

    return (
        <AutoComplete
            name='registeredOwner'
            floatingLabelText='Ship Owner'
            disabled={confirmed}
            searchText={registeredOwnerObject.name}
            dataSource={companies}
            dataSourceConfig={{ text: 'name', value: 'company' }}
            onUpdateInput={changeAutoCompete}
            onNewRequest={chooseAutoComplete}
            filter={AutoComplete.noFilter}
            errorText={getError('owner')}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            popoverProps={{
                canAutoPosition: true,
            }}
            fullWidth

            underlineStyle={modifiedFields && modifiedFields.includes('owner') ? underStyle : null}
        />
    );
}

export default RegisteredOwner;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/RegisteredOwner.jsx